import { useEffect, useState } from 'react'
import LocationIcon from '../../../../media/shared-access/ic-location.svg'
import AttacthmentIcon from '../../../../media/shared-access/ic-attachment.svg'
import WriteWithAI from './write-with-AI'
import { useIntl } from 'react-intl'
import { ErrorMessage, Field } from 'formik'
import { InboxQuill } from './InboxQuill'
import { useAuth } from '../../auth'
import {
  createAiComposeEmail,
  createMessage,
  deleteEmails,
  getEmail,
  updateMessage,
} from '../core/_requests'
import { toast } from 'react-toastify'
import { FileUpload } from '../../widgets/components/FileUpload'
import deleteicon from '../../../../media/shared-access/ic-delete_red.svg'
import docIcon from '../../../../media/shared-access/ic_doc.svg'
import pdfIcon from '../../../../media/shared-access/ic_pdf.svg'
import imgIcon from '../../../../media/shared-access/ic-image.svg'
import AiIcon from '../../../../media/shared-access/ic_ai.svg'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import Skeleton from 'react-loading-skeleton'
import { ConfirmationModal } from './ConfirmationModal'
import { errorMessage } from '../../profile/core/_constants'
// import TagifyInput from './tagify-input'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../hooks/gtmHelpers'

const ComposeEmail = ({
  userInfo,
  setStatus,
  status,
  isNewMessageClicked,
  setIsNewMessageClicked,
  initialValues,
  formik,
}: any) => {
  const { formatMessage } = useIntl()
  const [showCc, setShowCc] = useState(false)
  const [showBcc, setShowBcc] = useState(false)
  const [quillText, setQuillText] = useState('')
  const { companyId, setShowBillingModal, currentUser } = useAuth()
  const [modelStatus, setModelStatus] = useState<boolean>(false)
  const [isActive, setIsActive] = useState(false)
  const [storeFileIds, setStoreFileIds] = useState<any>([])
  const [searchParams] = useSearchParams()
  const emailId = searchParams.get('id')
  const isDeleted = searchParams.get('isDeleted')
  const [emailData, setEmailData] = useState<any>()
  const [isDiscard, setIsDiscard] = useState<boolean>(false)
  const navigate = useNavigate()
  const location = useLocation()
  const [emailLoading, setEmailLoading] = useState<boolean>(false)
  const [isSending, setIsSending] = useState<boolean>(false)
  const [isSaving, setIsSaving] = useState<boolean>(false)
  const [modalOpen, setModalOpen] = useState<boolean>(false)
  const [isDeleting, setIsDeleting] = useState<boolean>(false)
  const [selectedEmails, setSelectedEmails] = useState<string[]>([])
  const [aiEmailResponse, setAiEmailResponse] = useState<string>()
  const [aiEmails, setAiEmails] = useState<any[]>([])
  const [isAiEmailGenerating, setIsAiEmailGenerating] = useState<boolean>(false)
  const [aiPrompt, setAiPrompt] = useState('')

  function handleIsActive() {
    setIsActive(() => !isActive)
  }

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    setModelStatus(true)
  }
  const handleClose = () => {
    setModelStatus(false)
  }

  const handleRemoveClick = (fileId: string) => {
    setStoreFileIds((prevFiles: any) => prevFiles.filter((file: any) => file.fileId !== fileId))
  }

  const transformField = (ccString: string) => {
    return ccString
      .split(',')
      .map((email) => email.trim())
      .filter((email) => email.length > 0)
      .map((email) => ({ email }))
  }

  const emailSent = async (formik: any, isDraft: boolean) => {
    if (isDraft) {
      setIsSaving(true)
    } else {
      setIsSending(true)
    }
    try {
      if (companyId) {
        let payload: any
        payload = {
          toEmail: transformField(formik.values.to),
          subject: formik.values.subject,
          body: formik.values.quillText,
          fromEmail: userInfo,
          isDraft: isDraft,
          cc: transformField(formik.values.cc),
          bcc: transformField(formik.values.bcc),
          files: storeFileIds.map((file: any) => file.fileId),
        }
        console.log(payload, ' payload')
        const {
          data: { data, success, errors },
        }: any = await createMessage(companyId, payload)
        if (success) {
          setStatus('INBOX')
          console.log(data)
          toast.success(
            isDraft
              ? formatMessage({ id: 'Email Saved as Draft' })
              : formatMessage({ id: 'Email sent successfully' })
          )
          handleRedirection('inbox')
          TagManager.dataLayer({
            dataLayer: {
              event: isDraft
                ? GTMEvent.SharedAccessEmailSavedAsDraftSuccessful
                : GTMEvent.SharedAccessEmailSentSuccessful,
              action: 'normal',
              metadata: {
                company_id: companyId,
                to_email: transformField(formik.values.to),
                subject: formik.values.subject,
                from_email: userInfo,
                is_draft: isDraft,
                cc: transformField(formik.values.cc),
                bcc: transformField(formik.values.bcc),
                user_id: currentUser?.userId,
                email: currentUser?.email,
              },
            },
          })
        } else {
          errors.forEach((error: string) => {
            if (
              error === errorMessage.UPGRADE_BILLING_PLAN_LIMIT_EXCEEDED ||
              error === errorMessage.UPGRADE_BILLING_PLAN_FEATURE
            ) {
              setShowBillingModal(true)
              toast.error(formatMessage({ id: error }), { autoClose: false })
            } else {
              toast.error(formatMessage({ id: error }))
            }
          })
          TagManager.dataLayer({
            dataLayer: {
              event: isDraft
                ? GTMEvent.SharedAccessEmailSavedAsDraftFailed
                : GTMEvent.SharedAccessEmailSentFailed,
              action: 'normal',
              metadata: {
                company_id: companyId,
                to_email: transformField(formik.values.to),
                subject: formik.values.subject,
                from_email: userInfo,
                is_draft: isDraft,
                cc: transformField(formik.values.cc),
                bcc: transformField(formik.values.bcc),
                user_id: currentUser?.userId,
                email: currentUser?.email,
                error: errors[0],
              },
            },
          })
        }
      }
    } catch (err) {
      console.log(err)
      TagManager.dataLayer({
        dataLayer: {
          event: isDraft
            ? GTMEvent.SharedAccessEmailSavedAsDraftFailed
            : GTMEvent.SharedAccessEmailSentFailed,
          action: 'normal',
          metadata: {
            company_id: companyId,
            to_email: transformField(formik.values.to),
            subject: formik.values.subject,
            from_email: userInfo,
            is_draft: isDraft,
            cc: transformField(formik.values.cc),
            bcc: transformField(formik.values.bcc),
            user_id: currentUser?.userId,
            email: currentUser?.email,
            error: err,
          },
        },
      })
    } finally {
      if (isDraft) {
        setIsSaving(false)
      } else {
        setIsSending(false)
      }
    }
  }

  const updateEmail = async (formik: any, isDraft: boolean) => {
    setIsSaving(true)
    try {
      if (companyId && emailId) {
        let payload: any
        payload = {
          toEmail: transformField(formik.values.to),
          subject: formik.values.subject,
          body: formik.values.quillText,
          fromEmail: userInfo,
          isDraft: isDraft,
          cc: transformField(formik.values.cc),
          bcc: transformField(formik.values.bcc),
          files: storeFileIds.map((file: any) => file.fileId),
        }

        const {
          data: { data, success, errors },
        }: any = await updateMessage(companyId, emailId!, payload)
        if (success) {
          setStatus('INBOX')
          console.log(data)
          toast.success(formatMessage({ id: 'Email updated successfully' }))
          handleRedirection('inbox')
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.SharedAccessEmailUpdatedSuccessful,
              action: 'normal',
              metadata: {
                email_id: emailId,
                company_id: companyId,
                to_email: transformField(formik.values.to),
                subject: formik.values.subject,
                from_email: userInfo,
                is_draft: isDraft,
                cc: transformField(formik.values.cc),
                bcc: transformField(formik.values.bcc),
                user_id: currentUser?.userId,
                email: currentUser?.email,
              },
            },
          })
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.SharedAccessEmailUpdateFailed,
              action: 'normal',
              metadata: {
                email_id: emailId,
                company_id: companyId,
                to_email: transformField(formik.values.to),
                subject: formik.values.subject,
                from_email: userInfo,
                is_draft: isDraft,
                cc: transformField(formik.values.cc),
                bcc: transformField(formik.values.bcc),
                user_id: currentUser?.userId,
                email: currentUser?.email,
                error: errors[0],
              },
            },
          })
        }
      }
    } catch (err) {
      console.log(err)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.SharedAccessEmailUpdateFailed,
          action: 'normal',
          metadata: {
            email_id: emailId,
            company_id: companyId,
            to_email: transformField(formik.values.to),
            subject: formik.values.subject,
            from_email: userInfo,
            cc: transformField(formik.values.cc),
            bcc: transformField(formik.values.bcc),
            user_id: currentUser?.userId,
            email: currentUser?.email,
            error: err,
          },
        },
      })
    } finally {
      setIsSaving(false)
    }
  }
  const getFileIcon = (filename: string) => {
    const extension = filename?.includes('.') ? filename?.split('.').pop()?.toLowerCase() : ''
    let icon
    switch (extension) {
      case 'docx':
      case 'doc':
        icon = docIcon
        break
      case 'pdf':
        icon = pdfIcon
        break
      default:
        icon = imgIcon
        break
    }

    return <img src={icon} alt='Icon' />
  }

  const getMail = async () => {
    setEmailLoading(true)
    try {
      const {
        data: { success, error, data },
      } = await getEmail(companyId!, emailId!, status)
      if (success) {
        setEmailData(data)
        setIsNewMessageClicked(false)
        initialValues.subject = data.subject
        initialValues.quillText = data.body.replace(/(<([^>]+)>)/gi, '')
        initialValues.to = data.toEmail.map((item: { email: string }) => item.email).join(', ')
        initialValues.cc = data.cc.map((item: { email: string }) => item.email).join(', ')
        initialValues.bcc = data.bcc.map((item: { email: string }) => item.email).join(', ')
        if (data.sharedInboxAttachments) {
          initialValues.files = data.sharedInboxAttachments
            .map((attachment: any) => attachment.file)
            .map((file: any) => file.fileId)
          setStoreFileIds(data.sharedInboxAttachments.map((attachment: any) => attachment.file))
        }
      } else {
        toast.error(formatMessage({ id: error }))
      }
    } catch (err) {
      console.log(err)
    } finally {
      setEmailLoading(false)
    }
  }

  useEffect(() => {
    if (emailId) {
      getMail()
    }
  }, [emailId]) // eslint-disable-line react-hooks/exhaustive-deps

  const discard = () => {
    formik.setFieldValue('subject', '')
    formik.setFieldValue('quillText', '')
    formik.setFieldValue('to', '')
    formik.setFieldValue('cc', '')
    formik.setFieldValue('bcc', '')
    formik.setFieldValue('files', [])
    setIsDiscard(true)
  }

  const disCard = () => {
    discard()
    setModalOpen(true)
  }

  // useEffect(() => {
  //   if (isDiscard) {
  //     setModalOpen(true)
  //   }
  // }, [isDiscard])

  useEffect(() => {
    if (isNewMessageClicked && !emailId) {
      discard()
    }
  }, [isNewMessageClicked, emailId]) // eslint-disable-line react-hooks/exhaustive-deps

  const sendUpdateEmail = async () => {
    setIsSending(true)
    try {
      if (companyId && emailId) {
        let payload: any
        payload = {
          toEmail: transformField(formik.values.to),
          subject: formik.values.subject,
          body: formik.values.quillText,
          fromEmail: userInfo,
          isDraft: true,
          cc: transformField(formik.values.cc),
          bcc: transformField(formik.values.bcc),
          files: storeFileIds.map((file: any) => file.fileId),
        }
        const {
          data: { success, errors },
        }: any = await updateMessage(companyId, emailId!, payload)
        if (success) {
          const {
            data: { data, success },
          }: any = await updateMessage(companyId, emailId!, { isDraft: false })
          if (success) {
            console.log(' data email sent ', data)
            toast.success(formatMessage({ id: 'Email sent successfully' }))
            handleRedirection('inbox')
          }
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.SharedAccessEmailSentSuccessful,
              action: 'normal',
              metadata: {
                email_id: emailId,
                company_id: companyId,
                to_email: transformField(formik.values.to),
                subject: formik.values.subject,
                from_email: userInfo,
                cc: transformField(formik.values.cc),
                bcc: transformField(formik.values.bcc),
                user_id: currentUser?.userId,
                email: currentUser?.email,
              },
            },
          })
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.SharedAccessEmailSentFailed,
              action: 'normal',
              metadata: {
                email_id: emailId,
                company_id: companyId,
                to_email: transformField(formik.values.to),
                subject: formik.values.subject,
                from_email: userInfo,
                cc: transformField(formik.values.cc),
                bcc: transformField(formik.values.bcc),
                user_id: currentUser?.userId,
                email: currentUser?.email,
                error: errors[0],
              },
            },
          })
        }
      }
    } catch (err) {
      console.log(err)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.SharedAccessEmailSentFailed,
          action: 'normal',
          metadata: {
            email_id: emailId,
            company_id: companyId,
            to_email: transformField(formik.values.to),
            subject: formik.values.subject,
            from_email: userInfo,
            cc: transformField(formik.values.cc),
            bcc: transformField(formik.values.bcc),
            user_id: currentUser?.userId,
            email: currentUser?.email,
            error: err,
          },
        },
      })
    } finally {
      setIsSending(false)
    }
  }

  // const sendEmailMessage = async (isDraft: boolean) => {
  //   try {
  //     if (companyId) {
  //       let payload: any
  //       payload = {
  //         toEmail: transformField(formik.values.to),
  //         subject: formik.values.subject,
  //         body: formik.values.quillText,
  //         fromEmail: userInfo,
  //         isDraft: isDraft,
  //         cc: transformField(formik.values.cc),
  //         bcc: transformField(formik.values.bcc),
  //         files: storeFileIds.map((file: any) => file.fileId),
  //       }
  //       console.log(payload, ' payload')
  //       const {
  //         data: {data, success, errors},
  //       }: any = await createMessage(companyId, payload)
  //       console.log(data)
  //       if (success) {
  //         const {
  //           data: {data1, success, errors},
  //         }: any = await updateMessage(companyId, data.emailRecord.emailMessageId, {isDraft: false})
  //         console.log(data, ' datahh')
  //         console.log(data1, ' datahh22')
  //         if (success) {
  //           setStatus('INBOX')
  //           console.log(data)
  //           toast.success(formatMessage({id: 'Email sent successfully'}))
  //           handleRedirection('inbox')
  //         } else {
  //           errors.forEach((error: string) => {
  //             toast.error(formatMessage({id: error}))
  //           })
  //         }
  //       } else {
  //         errors.forEach((error: string) => {
  //           toast.error(formatMessage({id: error}))
  //         })
  //       }
  //     }
  //   } catch (err) {
  //     console.log(err)
  //   }
  // }

  const sendEmail = () => {
    if (emailId) {
      sendUpdateEmail()
    } else {
      emailSent(formik, false)
      // sendEmailMessage(true)
    }
  }

  const handleRedirection = (status: any) => {
    const searchParams = new URLSearchParams(location.search)
    if (searchParams.has('id')) {
      searchParams.delete('id')
    }
    searchParams.set('status', status)
    navigate(`${location.pathname}?${searchParams.toString()}`)
  }

  useEffect(() => {
    if (emailId) {
      setSelectedEmails([emailId])
    }
  }, [emailId])

  const deleteMails = async () => {
    setIsDeleting(true)
    try {
      let payload = {
        isDraft: true,
        ids: selectedEmails,
      }
      const {
        data: { success, error },
      } = await deleteEmails(companyId!, payload)
      if (success) {
        setStatus('INBOX')
        setModalOpen(false)
        handleRedirection('inbox')
        setSelectedEmails([])
        setIsDiscard(false)
        toast.success(formatMessage({ id: 'Email deleted successfully' }))
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.SharedAccessEmailDeletedSuccessful,
            action: 'normal',
            metadata: {
              email_ids: selectedEmails,
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
            },
          },
        })
      } else {
        toast.error(formatMessage({ id: error }))
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.SharedAccessEmailDeleteFailed,
            action: 'normal',
            metadata: {
              email_ids: selectedEmails,
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              error: error,
            },
          },
        })
      }
    } catch (err) {
      console.log(err)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.SharedAccessEmailDeleteFailed,
          action: 'normal',
          metadata: {
            email_ids: selectedEmails,
            company_id: companyId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            error: err,
          },
        },
      })
    } finally {
      setIsDeleting(false)
    }
  }

  const GenerateEmailByAi = async () => {
    setIsAiEmailGenerating(true)
    try {
      const payload = {
        prompt: aiPrompt,
      }
      const {
        data: { success, errors, data },
      }: any = await createAiComposeEmail(companyId!, payload, 'html')
      if (success) {
        setAiEmails(data.responses.slice(0, 4))
      } else {
        errors.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
      }
    } catch (err) {
      console.log(err)
    } finally {
      setIsAiEmailGenerating(false)
    }
  }

  return (
    <>
      <div className='d-block card'>
        <div className='border-bottom d-flex align-items-center px-4 min-h-60px'>
          <div className='text-gray-900 fw-bold'>{formatMessage({ id: 'New Message' })}</div>
        </div>
        {emailLoading ? (
          <>
            <div className='w-100 p-4'>
              <div className='pb-2'>
                <Skeleton
                  height={50}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              </div>
              <div className='pb-2'>
                <Skeleton
                  height={50}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              </div>
              <div>
                <Skeleton
                  height={300}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              </div>
            </div>
          </>
        ) : (
          <>
            <div className='border-bottom'>
              <div className='d-flex align-items-center px-4 min-h-50px'>
                <div className='text-dark fw-bold w-75px'>{formatMessage({ id: 'To:' })}</div>
                <Field
                  type='text'
                  className='form-control border-0 bg-transparent'
                  name='to'
                  disabled={isDeleted === 'true'}
                />
                <div className='ms-auto w-75px text-end'>
                  <span
                    className={`fw-normal cursor-pointer text-hover-primary me-2  ${showCc ? 'text-primary' : 'text-muted'
                      } `}
                    onClick={() => setShowCc(!showCc)}
                  >
                    {formatMessage({ id: 'Cc' })}
                  </span>
                  <span
                    className={`fw-normal cursor-pointer text-hover-primary me-2  ${showBcc ? 'text-primary' : 'text-muted'
                      } `}
                    onClick={() => setShowBcc(!showBcc)}
                  >
                    {formatMessage({ id: 'Bcc' })}
                  </span>
                </div>
              </div>
              <ErrorMessage name='to' component='div' className='text-danger px-4' />
            </div>

            {showCc && (
              <div className='border-bottom px-4'>
                <div className='d-flex '>
                  <div className={`text-dark fw-bold w-75px d-flex align-items-center`}>
                    {formatMessage({ id: 'CC:' })}
                  </div>
                  <Field
                    type='text'
                    className='form-control border-0 bg-transparent custom-disable'
                    name='cc'
                    disabled={isDeleted === 'true'}
                  />
                </div>

                <ErrorMessage name='cc' component='div' className='text-danger' />
              </div>
            )}
            {showBcc && (
              <div className=' border-bottom px-4'>
                <div className='d-flex'>
                  <div className='text-dark fw-bold w-75px d-flex align-items-center'>
                    {formatMessage({ id: 'BCC:' })}
                  </div>
                  <Field
                    type='text'
                    className='form-control border-0 bg-transparent'
                    name='bcc'
                    disabled={isDeleted === 'true'}
                  />
                </div>

                <ErrorMessage name='bcc' component='div' className='text-danger' />
                {/* <span
                      className='btn btn-clean btn-xs btn-icon'
                      onClick={() => setShowBcc(false)}
                    >
                      <i className='ki-duotone ki-cross fs-5'>
                        <span className='path1'></span>
                        <span className='path2'></span>
                      </i>
                    </span> */}
              </div>
            )}
            <div className='border-bottom d-flex align-items-center px-4'>
              <div className='w-75px text-dark fw-bold'>{formatMessage({ id: 'Subject:' })}</div>
              <Field
                className='form-control border-0 min-h-45px bg-transparent'
                name='subject'
                disabled={isDeleted === 'true'}
              />
              <ErrorMessage name='subject' component='div' className='text-danger' />
            </div>
            <div className='border-0 h-250px'>
              {/* <Field
                    className='form-control fw-normal border-0 px-8 min-h-45px'
                    name='body'
                    as='textarea'
                    placeholder={formatMessage({id: 'Enter Your Text Here'})}
                    rows={10}
                  /> */}
              <InboxQuill
                quillText={quillText}
                formik={formik}
                setQuillText={setQuillText}
                templateData={emailData}
                isDiscard={isDiscard}
                isDisable={isDeleted === 'true'}
                aiEmailResponse={aiEmailResponse}
              />
              <ErrorMessage name='body' component='div' className='text-danger' />
            </div>
          </>
        )}
      </div>
      <div className='bg-white border-top'>
        {emailLoading ? (
          <div className='w-100 d-flex p-4'>
            <div className='w-25'>
              <Skeleton
                height={50}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            </div>
            <div className='d-flex w-75 gap-4 justify-content-end'>
              <div className='w-25'>
                <Skeleton
                  height={50}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              </div>
              <div className='w-25'>
                <Skeleton
                  height={50}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              </div>
            </div>
          </div>
        ) : (
          <>
            {' '}
            {storeFileIds && storeFileIds.length > 0 && (
              <div className='bg-white px-8 py-8'>
                <div className='d-flex form-label text-dark font-size-13'>
                  {formatMessage({ id: 'Uploaded Files' })}{' '}
                </div>
                <div className='w-100'>
                  <ul className='p-0 m-0'>
                    {storeFileIds.length > 0 &&
                      storeFileIds.map((file: any) => (
                        <li
                          key={file.id}
                          className='d-flex align-items-center gap-2 text-decoration-none mb-2'
                        >
                          {getFileIcon(file.name)}
                          <p className='p-0 m-0'>{file.name.split('/').pop()}</p>
                          <button
                            className='btn btn-secondry p-0 m-0'
                            onClick={() => handleRemoveClick(file.fileId)}
                            disabled={isDeleted === 'true'}
                          >
                            <img src={deleteicon} alt='Delete' />
                          </button>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
            )}
            {isDeleted !== 'true' && (
              <div className='d-flex flex-stack flex-wrap gap-2 py-5 px-4 bg-white'>
                <div className='d-flex align-items-center'>
                  <button
                    type='button'
                    className='btn bg-light text-muted fw-normal px-4'
                    onClick={() => disCard()}
                  >
                    <span className='indicator-label'>{formatMessage({ id: 'Discard' })}</span>
                  </button>
                </div>
                <div className='d-flex align-items-center justify-content-between'>
                  <button
                    className='btn btn-icon btn-sm btn-clean btn-active-light-primary me-2'
                    onClick={handleIsActive}
                    type='button'
                  >
                    <img src={AiIcon} alt='' />
                  </button>
                  <button
                    className='btn btn-icon btn-sm btn-clean btn-active-light-primary me-2'
                    onClick={handleOpen}
                  >
                    <img src={AttacthmentIcon} alt='' />
                  </button>
                  <FileUpload
                    fileSize={26214400}
                    maxFileNumber={1}
                    allowType={[
                      'image/*',
                      '.jpg',
                      '.jpeg',
                      '.png',
                      'application/pdf',
                      'application/msword',
                      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                    ]}
                    metaData={{ module: 'doc+img', isProtected: true, companyId: companyId }}
                    modalStatus={modelStatus}
                    handleClose={handleClose}
                    handleSuccess={(fileId: number, name: string) => {
                      const newFile = { fileId, name }
                      setStoreFileIds((prevFileIds: any) => [...prevFileIds, newFile])
                    }}
                    resourceType='all'
                  />
                  <button className='btn btn-icon btn-sm btn-clean btn-active-light-primary'>
                    <img src={LocationIcon} alt='' />
                  </button>{' '}
                  <div className='btn-group me-4'>
                    <button
                      type='button'
                      className='btn bg-light text-muted fw-normal px-6 ms-4'
                      onClick={() => {
                        if (emailId) {
                          updateEmail(formik, true)
                        } else {
                          emailSent(formik, true)
                        }
                      }}
                      disabled={isSaving}
                    >
                      <span className='indicator-label'>
                        {isSaving
                          ? formatMessage({ id: 'Please wait...' })
                          : emailId
                            ? formatMessage({ id: 'Update Draft' })
                            : formatMessage({ id: 'Save As Draft' })}
                      </span>
                    </button>
                  </div>
                  <div className='btn-group'>
                    <button
                      type='button'
                      className='btn bg-primary text-white custom-button-property fw-normal px-6'
                      disabled={isSending}
                      onClick={() => sendEmail()}
                    >
                      <span className='indicator-label'>
                        {isSending
                          ? formatMessage({ id: 'Please wait...' })
                          : formatMessage({ id: 'Send' })}
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>
      <WriteWithAI
        isActive={isActive}
        setIsActive={setIsActive}
        handleIsActive={handleIsActive}
        setAiEmailResponse={setAiEmailResponse}
        setAiEmails={setAiEmails}
        aiEmails={aiEmails}
        GenerateEmailByAi={GenerateEmailByAi}
        aiPrompt={aiPrompt}
        setAiPrompt={setAiPrompt}
        isAiEmailGenerating={isAiEmailGenerating}
      />
      <ConfirmationModal
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        deleteMails={deleteMails}
        isDeleting={isDeleting}
      />
    </>
  )
}

export default ComposeEmail
